import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import DiariosProducaoTabela from "./DiariosProducaoTabela";
import DiarioProducaoDialog from "./DiarioProducaoDialog";



const useStyles = makeStyles(theme => ({

}));


const DiariosProducaoMainView = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dialogOpen, setDialogOpen] = useState(false);


    useEffect( () => {



    }, []);

    const cbOpenDialog = (b) => {
        console.log("mainview.cbOpenDialog", b)
        setDialogOpen(b);
    }


    return (
        <React.Fragment>
            { dialogOpen && <DiarioProducaoDialog isOpen={dialogOpen} cbDialog={cbOpenDialog}/>}
                <DiariosProducaoTabela openDialog={cbOpenDialog}/>
        </React.Fragment>
    )

}

export default DiariosProducaoMainView;
